import { PeoplePicker, PersonType } from "@microsoft/mgt-react";

import styles from "./AlternateApproverSelect.module.scss";
import { useEmployee } from "../../../hook";

interface Props {
  value?: any;
  onChange?: (value: any) => void;
  placeholder?: string;
}

export const AlternateApproverSelect = (props: Props) => {
  const { onChange = () => {}, placeholder = "Thủ trưởng CQ/ĐV" } = props;

  const { data: employees } = useEmployee();

  const onApproverPickerChange = (selectedOptions: any) => {
    let alternateApprover;

    if (selectedOptions.target.selectedPeople.length === 0) {
      onChange(undefined);
      return;
    }
    const selectedEmployee = selectedOptions.target.selectedPeople[0];
    const employee = employees.find(
      (e) => e.eMail === selectedEmployee.userPrincipalName
    );
    if (employee) {
      alternateApprover = `${employee.eMail}|${employee.Title}`;
    } else {
      alternateApprover = `${selectedEmployee?.userPrincipalName}|${selectedEmployee?.displayName}`;
    }

    onChange(alternateApprover);
  };

  return (
    <div className={styles.wrapper}>
      <PeoplePicker
        className="people-picker"
        placeholder={placeholder}
        type={PersonType.any}
        selectionChanged={onApproverPickerChange}
      />
    </div>
  );
};
